﻿export interface ILocation {
    id: string;
    submissionId: string;
    addressId: string;    
    buildingAmount: number;
    personalPropertyAmount: number;
    salesTotal: number;
    salesDelivery: number;
    salesLiquor: number;
    payrollRestaurant: number;
    payrollDelivery: number;
    payrollClerical: number;
    numberOfFullTimeEmployees: number;
    numberOfPartTimeEmployees: number;
    name: string;
    statusCId: number;
    territoryCodeLiability: string;
    territoryCodeProperty: string;
    territoryCodeAuto: string;
}

export class Location implements ILocation {
    public id: string;
    public submissionId: string;
    public addressId: string;    
    public buildingAmount: number;
    public personalPropertyAmount: number;
    public salesTotal: number;
    public salesDelivery: number;
    public salesLiquor: number;
    public payrollRestaurant: number;
    public payrollDelivery: number;
    public payrollClerical: number;
    public numberOfFullTimeEmployees: number;
    public numberOfPartTimeEmployees: number;
    public name: string;
    public statusCId: number;
    public territoryCodeAuto: string;
    public territoryCodeLiability: string;
    public territoryCodeProperty: string;
}